(ns practitest.frontend.components.history
  (:require
    [practitest.frontend.components.grid :as grid]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.events :as events]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [re-frame.db]))

(def container-min-height "600px")
(def container-max-height "600px")

(defn history [entity]
  [:div.row
   [:div.col
    ;; Grid must have "flex" container if you want to limit min and max height
    [:div.d-flex {:style {:min-height container-min-height
                          :max-height container-max-height}}
     [grid/grid
      {:loading?        (re-frame/subscribe [::subs/progress? ::events/fetch-history])
       :columns         (re-frame/subscribe [::grid.subs/columns [entity :history]])
       :data            (re-frame/subscribe [::grid.subs/history [entity]])

       ;; Required for users filter to work correctly
       :get-field-props (fn [field]
                          ;; TODO: fix this, it's really ugly
                          (re-frame/subscribe [::subs/field-props entity (if (= :user_id field)
                                                                           :author
                                                                           field)]))}]]]])
